import React from 'react';
import Card from "./Card.jsx";
import styles from '../Catalog.module.css';
import {FadeIn} from "@/shared/ui/animations/index.js";

class Cards extends React.Component {
    render() {
        const { cards, type, cardsPerPage = 6 } = this.props;

        return (
            <>
                {(Array.isArray(cards) ? cards : []).length > 0 ? (
                    <>
                        <div className={styles.cardsGrid}>
                            {cards.map((card, index) => {
                                const delayIndex = index % cardsPerPage;
                                const delay = 80 * delayIndex;

                                return (
                                    <FadeIn key={`${type}-${card.id}-${index}`} delay={delay}>
                                        <div className={styles.card}>
                                            <Card
                                                imageUrl={card.imageUrl}
                                                title={card.title}
                                                description={card.description}
                                                gameSystemName={card.gameSystemName}
                                                gameFormat={card.gameFormat}
                                                cost={card.cost}
                                                isCampaign={type === 'campaign'}
                                                minAge={card.minAge}
                                            />
                                        </div>
                                    </FadeIn>
                                );
                            })}
                        </div>
                    </>
                ) : (
                    <FadeIn delay={200}>
                        <h2 className="text-center">Игр нет</h2>
                    </FadeIn>
                )}
            </>
        );
    }
}

export default Cards;
